import React from 'react';
import SearchableDropdown from './SearchableDropdown';
import { formatLanguage } from '../data/languages';

interface LanguageTagProps {
    language: string | null;
    editable?: boolean;
    onLanguageChange?: (language: string | null) => void;
    disableNoLanguage?: boolean;
}

const LanguageTag: React.FC<LanguageTagProps> = ({
    language,
    editable = false,
    onLanguageChange,
    disableNoLanguage = false,
}) => {
    if (editable && onLanguageChange) {
        return (
            <SearchableDropdown
                selectedValue={language}
                onSelect={onLanguageChange}
                disableNoLanguage={disableNoLanguage}
            />
        );
    }

    return (
        <span className="language-tag">
            {language ? language.toUpperCase() : 'NO LANG'}
        </span>
    );
};

export default LanguageTag;
